import './HeaderGenericSecondary.css';
import React from 'react';
import { get } from '../../utils';
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { commonStyles, ltrStyles, rtlStyles } from '../57_HeaderGenericPrimary/HeaderGenericPrimary';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import { fullWidthStyles } from '../57_HeaderFullWidth/headerFullWidth';
import DarkThemeControl from '../BrightcoveVideosAtoms/DarkThemeControl';
var HeaderGenericSecondary = function HeaderGenericSecondary(_ref) {
  var rendering = _ref.rendering,
    fields = _ref.fields,
    children = _ref.children,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var darkMode = get(sitecoreContext, 'darkMode');
  var actions = get(sitecoreContext, 'actions', {});
  var _actions$changeThemeF = actions.changeThemeFunction,
    changeThemeFunction = _actions$changeThemeF === void 0 ? function () {} : _actions$changeThemeF;
  if (!fields) {
    console.warn('HeaderGenericSecondary component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [HeaderGenericLegislation component is empty: please provide data source]");
    }
    return null;
  }
  var hasTitle = Boolean(get(fields, 'pageTitle.value'));
  var hasText = Boolean(get(fields, 'pageIntro.value'));
  var hasName = Boolean(get(fields, 'pageName.value')); // eslint-disable-line
  // const hasHeaderTag: boolean = Boolean();
  var pageName = get(fields, 'headerTag');
  var dotSite = get(sitecoreContext, 'site.name');
  if (dotSite === 'dotsite') {
    pageName = get(fields, 'pageName');
  }
  var renderMediaPlaceholder = function renderMediaPlaceholder() {
    return /*#__PURE__*/React.createElement(Placeholder, {
      name: "dot-media-header-secondary",
      rendering: rendering,
      mediaDesc: fields.pageIntro.value
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "header header-generic--secondary ".concat(pageEditing && onPageEditor)
  }, /*#__PURE__*/React.createElement("div", {
    className: "dark-mode-switcher-box item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1 col-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-7 col-7"
  }, params && params['Dark Mode Switcher Show'] && /*#__PURE__*/React.createElement(DarkThemeControl, {
    handleClick: changeThemeFunction,
    label: 'Dark mode',
    value: darkMode,
    params: params
  }))), /*#__PURE__*/React.createElement("div", {
    className: "module-group module-group--inside no-padding-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-11"
  }, pageName && pageName.value && /*#__PURE__*/React.createElement("div", {
    className: "header__category"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    field: pageName,
    className: "c-category__text"
  })), hasTitle && /*#__PURE__*/React.createElement("div", {
    className: "header__title"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    field: fields.pageTitle,
    className: "h2 c-title__text"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "header__media"
  }, process.env.STORYBOOK_MODE ? children : renderMediaPlaceholder()), /*#__PURE__*/React.createElement("div", {
    className: "module-group module-group--inside"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, hasText && /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "p header__content",
    field: fields.pageIntro
  }))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: " ".concat(commonStyles, " ").concat(fullWidthStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(commonStylesSpecific, " ").concat(headerImageStyle, " ").concat(thisHeaderStyles)
  }, children);
};
var commonStylesSpecific = "c1q9vhy7";
var thisHeaderStyles = "tkqzppl";
var onPageEditor = "o18bpany";
export default HeaderGenericSecondary;